var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { gtmSelectPromotion, gtmViewPromotion, useForceUpdate } from "../../services/misc.functions";
import { useEffect } from "react";
import { raffleDraws } from "../../store/games.store";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination } from "swiper";
import { api } from "../../services/http.service";
import { env } from "../../constants/global.constants";
import { homeSliderSubject, homeSlides } from "../../store/misc.store";
import { useNavigate } from "react-router";
import { isMobile } from "../../App";
import "swiper/css/pagination";
import { openRaffleDetail } from "../../services/game.service";
import _ from "lodash";
// Function to check if image is vertical and filter it out
var checkImageDimensions = function (imageUrl) {
    return new Promise(function (resolve) {
        var img = new Image();
        img.onload = function () {
            // If height > width, it's vertical - return false to filter it out
            // If width >= height, it's horizontal or square - return true to keep it
            resolve(img.width >= img.height);
        };
        img.onerror = function () {
            // If image fails to load, keep it by default (return true)
            resolve(true);
        };
        img.src = imageUrl;
    });
};
// Function to filter out vertical images from slide data
var filterVerticalImages = function (slides) { return __awaiter(void 0, void 0, void 0, function () {
    var filteredSlides, _i, slides_1, slide, imageUrl, isHorizontal, error_1;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                filteredSlides = [];
                _i = 0, slides_1 = slides;
                _a.label = 1;
            case 1:
                if (!(_i < slides_1.length)) return [3 /*break*/, 6];
                slide = slides_1[_i];
                _a.label = 2;
            case 2:
                _a.trys.push([2, 4, , 5]);
                imageUrl = env.accounting_api + "/media/" + slide.photo_web;
                return [4 /*yield*/, checkImageDimensions(imageUrl)];
            case 3:
                isHorizontal = _a.sent();
                if (isHorizontal) {
                    filteredSlides.push(slide);
                }
                return [3 /*break*/, 5];
            case 4:
                error_1 = _a.sent();
                // If there's an error checking dimensions, keep the slide by default
                filteredSlides.push(slide);
                return [3 /*break*/, 5];
            case 5:
                _i++;
                return [3 /*break*/, 1];
            case 6: return [2 /*return*/, filteredSlides];
        }
    });
}); };
export function HomeSlider() {
    var _this = this;
    var forceUpdate = useForceUpdate();
    var navigate = useNavigate();
    useEffect(function () {
        var homeSliderSubject_subscriber = homeSliderSubject.subscribe(function () {
            forceUpdate();
        });
        return function () {
            homeSliderSubject_subscriber.unsubscribe();
        };
    }, []);
    useEffect(function () {
        if (homeSlides.length === 0) {
            api.start("get", env.accounting_api + "/misc/api/list-slide/", null, false).then(function (res) { return __awaiter(_this, void 0, void 0, function () {
                var slideData, filteredSlideData;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            slideData = _.orderBy(res.data, ["ordering"], ["asc"]);
                            return [4 /*yield*/, filterVerticalImages(slideData)];
                        case 1:
                            filteredSlideData = _a.sent();
                            homeSlides.splice(0, homeSlides.length);
                            homeSlides.push.apply(homeSlides, filteredSlideData);
                            forceUpdate();
                            return [2 /*return*/];
                    }
                });
            }); });
        }
    }, []);
    return (_jsx("div", __assign({ style: { borderRadius: '8px', overflow: 'hidden' } }, { children: _jsx(Swiper, __assign({ className: "home-slider-swiper", spaceBetween: 20, slidesPerView: 1, loop: true, pagination: { clickable: true }, autoplay: { delay: 5000 }, modules: [Autoplay, Pagination], onSlideChange: function (e) {
                try {
                    var slide = homeSlides.filter(function (el) { return el.slide_page === 0; })[e.activeIndex];
                    gtmViewPromotion(slide.title, env.accounting_api + "/media/" + slide.photo_web, slide.web_url, slide.web_url);
                }
                catch (e) { }
            } }, { children: homeSlides
                .filter(function (el) { return el.slide_page === 0; })
                .map(function (el, key) {
                var btnLabel = "Şansını Kaçırma";
                if (el.web_url && el.web_url.indexOf("esya-piyangosu") !== -1 && el.web_url.split("/").length >= 4) {
                    var draw = raffleDraws.find(function (r) { return r.id === Number(el.web_url.split("/")[2]); });
                    if (draw) {
                        btnLabel = "Çekilişe Katıl";
                    }
                }
                if (el.web_url && el.web_url.indexOf("dijital-oyunlar") !== -1 && el.web_url.split("/").length >= 4) {
                    var draw = raffleDraws.find(function (r) { return r.id === Number(el.web_url.split("/")[2]); });
                    if (draw) {
                        btnLabel = "Oyna";
                    }
                }
                if (el.web_url && el.web_url.indexOf("puan-kazan") !== -1 && el.web_url.split("/").length >= 4) {
                    var draw = raffleDraws.find(function (r) { return r.id === Number(el.web_url.split("/")[2]); });
                    if (draw) {
                        btnLabel = "Oyna";
                    }
                }
                // console.log(!isMobile && el.slide_type === 0);
                // console.log(el.web_url);
                return (_jsx(SwiperSlide, { children: !isMobile && el.slide_type === 0 ? (_jsx(_Fragment, { children: _jsx("div", __assign({ className: "custom-slide" }, { children: _jsxs("div", __assign({ className: "row", style: { margin: '0' } }, { children: [_jsx("div", __assign({ className: "col-5 col-sm-5 col-lg-7 custom-center", style: { display: 'flex', justifyContent: 'center' } }, { children: _jsx("img", { src: env.accounting_api + "/media/" + (isMobile ? el.photo_mobile : el.photo_web), style: { height: '180px', width: 'auto', borderRadius: '8px !important', clipPath: 'inset(0 round 8px) !important' } }) })), _jsxs("div", __assign({ className: "col-7 col-sm-7 col-lg-5 p-5 px-lg-3 p-sm-1 py-lg-5 description" }, { children: [_jsx("h2", { children: el.title }), _jsx("div", { dangerouslySetInnerHTML: { __html: el.content.replaceAll("\n", "<br/>") } }), el.web_url && (_jsx("button", __assign({ onClick: function () {
                                                    gtmSelectPromotion(el.title, env.accounting_api + "/media/" + el.photo_web, el.web_url, el.web_url);
                                                    if (el.web_url.includes("https://")) {
                                                        window.open(el.web_url, "_blank");
                                                    }
                                                    else {
                                                        if (el.web_url.indexOf("esya-piyangosu") !== -1 &&
                                                            el.web_url.split("/").length >= 4) {
                                                            var draw = raffleDraws.find(function (r) { return r.id === Number(el.web_url.split("/")[2]); });
                                                            if (draw) {
                                                                openRaffleDetail(draw);
                                                                btnLabel = "Çekilişe Katıl";
                                                            }
                                                            else {
                                                                navigate("".concat(el.web_url, "?n=/"));
                                                            }
                                                        }
                                                        else {
                                                            navigate("".concat(el.web_url, "?n=/"));
                                                        }
                                                    }
                                                }, className: "btn btn-primary fw-bolder py-3 fs-5  w-100 rounded-3" }, { children: btnLabel })))] }))] })) })) })) : (_jsx(_Fragment, { children: _jsx("div", __assign({ className: "image-slide", style: { display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: 'auto', padding: '0', borderRadius: '8px' }, onClick: function () {
                                gtmSelectPromotion(el.title, env.accounting_api + "/media/" + el.photo_web, el.web_url, el.web_url);
                                if (el.web_url.includes("https://")) {
                                    window.open(el.web_url, "_blank");
                                }
                                else {
                                    if (el.web_url.indexOf("esya-piyangosu") !== -1 && el.web_url.split("/").length >= 4) {
                                        var draw = raffleDraws.find(function (r) { return r.id === Number(el.web_url.split("/")[2]); });
                                        if (draw) {
                                            openRaffleDetail(draw);
                                        }
                                        else {
                                            navigate("".concat(el.web_url, "?n=/"));
                                        }
                                    }
                                    else {
                                        navigate("".concat(el.web_url, "?n=/"));
                                    }
                                }
                            } }, { children: _jsx("img", { src: env.accounting_api + "/media/" + el.photo_web, style: { height: '200px', width: 'auto', borderRadius: '8px !important', clipPath: 'inset(0 round 8px) !important' } }) })) })) }, "home-slider-items-".concat(key)));
            }) })) })));
}
